import Firebase from './Firebase';
import FirebaseContext, { withFirebase } from './Firebase-context';

export default Firebase;
export { FirebaseContext, withFirebase };
